import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { Row, Col } from "react-bootstrap";
import FileUpload from "../Assets/Images/file-upload.svg";
import "../Styles/RoleManagement.css";
import "../Styles/Artcle.css";
import { useAddBusinessMaterialTYpeMutation } from "../Services/SecondaryApi";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Swal from 'sweetalert2';

function RoleManagementRegister({ show, handleCloseMaterialTypeModal, refetch }) {
    const [selectedLogo, setSelectedLogo] = useState(null);
    const [value, setValue] = useState('');
    const [loading, setLoading] = useState(false); // Loading state
    const [submitLogin, { isLoading, isError, isSuccess, error }] = useAddBusinessMaterialTYpeMutation();

    const handleCloseAddNewModal = () => {
        if (!loading) handleCloseMaterialTypeModal(); // Only allow closing if not loading
    };

    const [formData, setFormData] = useState({
        category_name: '',
        logo: null,
    });
    const [errors, setErrors] = useState({});


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    
        // Clear the error for category_name if there’s an existing error
        if (name === 'category_name' && errors.category_name) {
            setErrors((prevErrors) => ({ ...prevErrors, category_name: '' }));
        }
    };
    useEffect(() => {
        if (isSuccess) {
            refetch();
        }
    }, [isSuccess])

    const handleLogoChange = (e) => {
        const file = e.target.files[0];
        setSelectedLogo(file);
        if (file) {
            // Validate file type to ensure it's JPG, PNG, or JPEG
            const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
            if (!validTypes.includes(file.type)) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    logo: 'Only JPG, PNG, and JPEG files are allowed',
                }));
            }
            // Validate file size (less than 1 MB)
            else if (file.size > 1024 * 1024) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    logo: 'File size must be less than 1 MB',
                }));
            } else {
                // Clear errors if file is valid and update the form data
                setErrors((prevErrors) => ({ ...prevErrors, logo: '' }));
                setFormData({ ...formData, logo: file });
            }
        }
    };

    const validateForm = () => {
        const errors = {};

        // Category name validation
        if (!formData.category_name) {
            errors.category_name = 'Field is required';
        } else if (formData.category_name.length > 50) {
            errors.category_name = 'Category name must be less than 50 characters';
        } else if (/[^a-zA-Z0-9 ]/.test(formData.category_name)) {
            errors.category_name = 'No special characters are allowed';
        }

        setErrors(errors);
        return Object.keys(errors).length === 0;
    };


    // const handleLogoChange = (e) => {
    //     const file = e.target.files[0];
    //     if (handleFileValidation(file, ["jpg", "png", "svg"])) {
    //         setSelectedLogo(file);
    //     } else {
    //         alert("Invalid file type. Only .jpg, .png, and .svg files are allowed.");
    //         setSelectedLogo(null);
    //     }
    // };

    const handleFileValidation = (file, allowedTypes) => {
        const fileType = file.type.split("/")[1].toLowerCase();
        return allowedTypes.includes(fileType);
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        setLoading(true);

        const data = new FormData();
        data.append('name', formData.category_name);
        console.log("selectedLogo", selectedLogo);
        if (selectedLogo) {
            data.append('image', selectedLogo);
        }

        try {
            const response = await submitLogin(data);
            if (response.error) {
                // alert("Submission failed!");
                Swal.fire({
                    icon: 'error',
                    title: 'Submission Failed',
                    text: 'An error occurred. Please try again.',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                  });
            } else {
                // alert("Added successfully!");
                Swal.fire({
                    icon: 'success',
                    title: 'Submission Successful!',
                    text: 'Added successfully!',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                  }).then(() => {
                setFormData({
                    category_name: "",
                });
                setSelectedLogo(null);

                handleCloseAddNewModal();
                refetch();
            });
            }
        } catch (error) {
            console.error('Error submitting form:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Modal
                show={show}
                onHide={handleCloseMaterialTypeModal}
                backdrop="true"
                dialogClassName="add-new-modal"
            >
                <Modal.Body>
                    <h4>Add</h4>
                    <form onSubmit={handleSubmit}>
                        <Row>

                            <Col xs={12} sm={12} md={12} lg={12}>
                                <div className="form-control">
                                    <label>Material type <span className="red-star">*</span></label>
                                    <br />
                                    <input
                                        type="text"
                                        name="category_name"
                                        placeholder="Enter Material type"
                                        value={formData.category_name}
                                        onChange={handleChange}
                                        disabled={loading}
                                    />
                                    {errors.category_name && <p className="error-text">{errors.category_name}</p>}

                                </div>
                            </Col>


                            {/* <Col xs={12} sm={12} lg={12} md={12}>
                                <label>Upload</label>
                                <div className="file-upload-container d-flex">
                                    <label className="file-upload-label">
                                        <input
                                            type="file"
                                            className="file-upload-input"
                                            onChange={handleLogoChange}
                                            disabled={loading}
                                        />
                                        <div>
                                            <img src={FileUpload} alt="FileUpload" />
                                        </div>
                                        <div>
                                            <span className="file-upload-text">
                                                {formData.logo ? formData.logo.name : 'Please select a file'}
                                            </span>
                                            <span className="format-text">(Only supports .jpeg/.png files)</span>
                                        </div>
                                    </label>
                                </div>
                                {errors.logo && <p className="error-text">{errors.logo}</p>}
                            </Col> */}

                        </Row>
                        <Row>
                            <div className="btn-action">
                                <button
                                    type="button"
                                    className="btn-outline-black"
                                    onClick={handleCloseAddNewModal}
                                    disabled={loading}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn-primary"
                                    disabled={loading}
                                >
                                    {loading ? "Submitting..." : "Add"}
                                </button>
                            </div>
                        </Row>
                    </form>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default RoleManagementRegister;
